var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { Button } from '@ui/atoms/Button';
import { showSuccessToast, showErrorToast } from '@ui';
import { translate } from '@utils/i18n';
import { NAMESPACE } from './constants';
import { useConflictResolution } from './hooks/useConflictResolution';
import { acceptByTechnician } from './services/conflictResolutionService';
import AcceptByTechnicianModal from './components/AcceptByTechnicianModal';
export default function ConflictsListing({ inspectionId, permissions }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { summary, isLoading, hasError } = useConflictResolution(inspectionId, isOpen);
    if (!permissions.resolve)
        return null;
    const handleConfirm = (technicianId) => __awaiter(this, void 0, void 0, function* () {
        setIsSubmitting(true);
        try {
            yield acceptByTechnician(inspectionId, technicianId);
            setIsOpen(false);
            showSuccessToast(translate('started', { namespace: NAMESPACE }));
        }
        catch (_a) {
            showErrorToast(translate('failed', { namespace: NAMESPACE }));
        }
        finally {
            setIsSubmitting(false);
        }
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { variant: "default", type: "button", onClick: () => setIsOpen(true) },
            React.createElement("i", { className: "fa-light fa-user-check" }),
            translate('accept_by_technician', { namespace: NAMESPACE })),
        React.createElement(AcceptByTechnicianModal, { isOpen: isOpen, isSubmitting: isSubmitting, isLoading: isLoading, hasError: hasError, summary: summary, onClose: () => setIsOpen(false), onConfirm: handleConfirm })));
}
